import moment from 'moment';

export interface IPrescriptions {
  prescriptionCode: string;
  prescriptionMetadata: ScriptMetadata;
  prescriptions: Prescription[];
}

export type Prescription = {
  createdDate: string;
  expiryDate: string;
  inActive: boolean;
  interval: number | null;
  presciptionCode: string;
  productName: string;
  productActive: boolean;
  quantity: number;
  repeats: string;
  status: string;
  productId: number;
  thcStrength?: string;
  cbdStrength?: string;
  dosage?: string;
};

export interface ScriptMetadata {
  createdDate: string;
  expiryDate: string;
  status: string;
  inActive: boolean;
  daysUntilExpiry: number;
}

export function getUniqueKey(prescription: Prescription) {
  return `${prescription.presciptionCode}-${prescription.productName}`;
}

export function getCreatedDate(prescription: Prescription) {
  return prescription.createdDate ? moment(prescription.createdDate).format('DD-MMM-YYYY') : '-';
}

export function getCode(prescription: Prescription) {
  return prescription.presciptionCode || '-';
}

export function getProductName(prescription: Prescription) {
  return prescription.productName || '-';
}

export function getQuantity(prescription: Prescription) {
  return prescription.quantity || '-';
}

export function getInterval(prescription: Prescription) {
  return prescription.interval ? `${prescription.interval} days` : '-';
}

export function getExpiryDate(prescription: Prescription) {
  return prescription.expiryDate ? moment(prescription.expiryDate).format('DD-MMM-YYYY') : '-';
}

export function getStatus(prescriptionMetadata: ScriptMetadata) {
  if (prescriptionMetadata.inActive) {
    return 'Inactive';
  }
  return prescriptionMetadata.status || '-';
}

export function getDaysUntilExpiry(prescription: Prescription) {
  return Math.max(moment(prescription.expiryDate).diff(moment(), 'days'), 0);
}
